import { render, staticRenderFns } from "./branch-admin.vue?vue&type=template&id=6528410c&"
import script from "./branch-admin.vue?vue&type=script&lang=js&"
export * from "./branch-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports